import { createFileRoute } from '@tanstack/react-router'

import {
  DocumentBlocks,
  DocumentFailed,
  DocumentNotStarted,
  DocumentProcessing,
  DocumentSkeleton,
  DocumentViewer,
  useDocument,
  useDocumentWebsocket,
} from '@/modules/documents'
import {
  hasDocumentFailed,
  isDocumentProcessing,
  isDocumentStatus,
} from '@/modules/documents/status'

export const Route = createFileRoute('/_authenticated/documents/$id/')({
  staticData: { title: 'Document' },
  component: DocumentView,
})

function DocumentView() {
  useDocumentWebsocket()
  const document = useDocument()

  if (!document) {
    return <DocumentSkeleton />
  }

  if (isDocumentStatus(document, 'notStarted')) {
    return <DocumentNotStarted />
  }

  if (isDocumentProcessing(document)) {
    return <DocumentProcessing />
  }

  if (hasDocumentFailed(document)) {
    return <DocumentFailed />
  }

  return (
    <div className="flex flex-1 gap-4 min-h-0">
      <DocumentBlocks />
      <DocumentViewer />
    </div>
  )
}
